var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"outlined":""},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-btn',_vm.$attrs,false),_vm.inputListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }